import React from "react";
import "./Switch.css";
interface Props {
  onToggle: (isEnabled: boolean) => unknown;
  title?: string;
  description?: string;
  isEnabled: boolean;
}
export const Switch = ({ onToggle, title, description, isEnabled }: Props) => {
  const switchToggle = () => {
    onToggle(isEnabled);
  };

  return (
    <div className="wrapper">
      <div className="switch-wrapper">
        {title ? <div id="title">{title}</div> : <></>}
        <div className="switch-container">
          <div
            className="switch"
            id={isEnabled ? "enabled-switch" : "disabled-switch"}
            onClick={switchToggle}
          >
            <div
              className="switch-circle"
              id={isEnabled ? "enabled-circle" : "disabled-circle"}
            ></div>
          </div>
        </div>
      </div>

      <div>
        {description ? <div id="description">{description}</div> : <></>}
      </div>
    </div>
  );
};
